import React from 'react';
export const CallToAction = () => {
  return <section className="py-16 bg-white" data-id="element-40">
      <div className="container mx-auto px-4" data-id="element-41">
        <div className="bg-primary-dark rounded-lg overflow-hidden shadow-xl" data-id="element-42">
          <div className="relative p-12 md:p-16" data-id="element-43">
            {/* Gold accents */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gold" data-id="element-44"></div>
            <div className="absolute bottom-0 right-0 w-40 h-40 rounded-full border-8 border-gold opacity-10" data-id="element-45"></div>
            <div className="relative z-10 flex flex-col md:flex-row items-center justify-between" data-id="element-46">
              <div className="text-center md:text-left mb-8 md:mb-0" data-id="element-47">
                <h2 className="text-gold font-serif text-3xl md:text-4xl font-bold mb-4" data-id="element-48">
                  Ready to Elevate Your Business?
                </h2>
                <p className="text-white text-lg max-w-2xl" data-id="element-49">
                  Book a confidential consultation with our experts to discuss
                  your business needs and discover how Niqqanno Consulting can
                  help you achieve your objectives.
                </p>
              </div>
              <a href="mailto:niqqannoconsult21@gmail.com?subject=Consultation%20Request&body=I'm%20interested%20in%20booking%20a%20consultation%20with%20Niqqanno%20Consulting." className="bg-gold text-primary-dark px-8 py-4 rounded-md font-medium hover:bg-gold-light transition-colors duration-300 whitespace-nowrap" data-id="element-50">
                Book Your Consultation
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
};